import { KebabButton } from '@components/ui/KebabButton/KebabButton';
import { Menu } from '@components/ui/Menu/Menu';
import styles from './cardList.module.css';

export interface ICardMenuItem {
  label: string;
  onSelect: () => void;
  danger?: boolean;
  /** Shown but not pickable — an action the item isn't ready for yet. */
  disabled?: boolean;
}

export interface ICardMenuProps {
  /** The trigger's accessible name. */
  label: string;
  items: ICardMenuItem[];
}

/**
 * A card's overflow menu, behind the shared kebab trigger. Every event is stopped at the menu so choosing an action
 * never also opens the card it sits on.
 */
export function CardMenu({ label, items }: ICardMenuProps) {
  return (
    <Menu.Root>
      <Menu.Trigger
        render={<KebabButton className={styles.kebab} aria-label={label} />}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      />
      <Menu.Portal>
        <Menu.Positioner side="bottom" align="end">
          <Menu.Popup>
            {items.map((item) => (
              <Menu.Item
                key={item.label}
                className={item.danger ? styles.menuDanger : undefined}
                disabled={item.disabled}
                onClick={(event) => {
                  event.stopPropagation();
                  item.onSelect();
                }}
              >
                {item.label}
              </Menu.Item>
            ))}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
}
